<template>
    <h2>
        <slot />
    </h2>
</template>

<style scoped>
h2 {
    font-weight: 500;
    padding: 10px 0 20px;
    margin-bottom: 10px;

    &::after {
        content: " ";
        display: block;
        width: 20px;
        height: 2px;
        background-color: var(--color-primary);
        margin-top: 25px;
    }
}
</style>
